import "bootstrap-5.3.3/js/dist/alert";
import "bootstrap-5.3.3/js/dist/button";
import "bootstrap-5.3.3/js/dist/collapse";
import "bootstrap-5.3.3/js/dist/dropdown";
// import 'bootstrap-5.3.3/js/dist/carousel';
import Modal from "bootstrap-5.3.3/js/dist/modal";
import "bootstrap-5.3.3/js/dist/offcanvas";
// import 'bootstrap-5.3.3/js/dist/popover';
// import 'bootstrap-5.3.3/js/dist/scrollspy';
import "bootstrap-5.3.3/js/dist/tab";
// import 'bootstrap-5.3.3/js/dist/toast';
// import Tooltip from 'bootstrap-5.3.3/js/dist/tooltip';

// tooltips need to be initialized manually
// const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
// tooltipTriggerList.map(function (tooltipTriggerEl) {
//   return new Tooltip(tooltipTriggerEl);
// });

window.bootstrap = {
  Modal,
};
